<template>
    <nav class="payment__nav payment__nav-full" role="navigation">
        <div class="payment__nav-header">
            <div class="wrapper">
                <button type="button" class="nav-min" @click="$emit('minimize')">
                    <svg
                        width="11"
                        height="17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M3.592 8.5l6.695-6.694a.538.538 0 000-.783L9.435.17A.539.539 0 009.043 0a.539.539 0 00-.391.17L.713 8.108a.538.538 0 000 .784l7.938 7.938a.538.538 0 00.784 0l.852-.852a.539.539 0 000-.783L3.591 8.5z"
                            fill="#000"
                        />
                    </svg>
                </button>
                <p>{{translate("ui.payment.options.all", "Payment Methods")}}</p>
            </div>
            <button @click="handleCloseIframe" type="button" class="close">
                <span>{{ translate("ui.close.btn", "Close")}} </span>
            </button>
        </div>
        <NavItem
            v-for="(option, index) in options"
            :key="index"
            :title="options.labels[option]"
            :name="option"
            v-bind="$attrs"
            :logo-name="option"
            :processing="state.processing"
            :backgroundProcessing="state.backgroundProcessing"
            @toggle-view-payments="emitToggleViewPayments"
            :active="currentPaymentOption === option"
            :index="index"
        />
    </nav>
</template>
<script>
import NavItem from "../nav-item.vue";
import { ref, onBeforeUnmount } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";

export default {
    components: {
        NavItem,
    },
    emits: ["toggle-view-payments", "minimize"],
    props: {
        options: {
            type: Array,
            required: true,
        },
        currentPaymentOption: {
            type: String,
            required: true,
        },
    },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        onBeforeUnmount(() => {
            subscription();
        });

        function handleCloseIframe(state) {
            store.Control.close(state);
        }

        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                backgroundProcessing: (state) => getValueFromPath(state, "backgroundProcessing") || false,
            }),
            handleCloseIframe,
            checkoutData,
        };
    },
};
</script>